import { Layout, Menu, Image, Drawer, Button } from 'antd';
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { AboutResearchers } from './PageAboutResearchers';
import { MenuOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import './App.css';
import './ColourScheme.css';
import { PageDataDonation } from './PageDataDonation';
import { TikTokRequest } from './PageTikTokRequest';
import { YouTubeRequest } from './PageYouTubeRequest';
import { InstagramRequest } from './PageInstagramRequest';
import { AppFooter } from './AppFooter';
import { PageHome } from './PageHome';
import logo from './Images/MPI_Logo_White.png';

const { Content, Header } = Layout;
const { Sider } = Layout;
const { SubMenu } = Menu;

const App = () => {

  React.useEffect(() => {
    document.title = "Social Donator"
  }, []);

  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [currentMenuItem, setCurrentMenuItem] = useState(window.location.pathname);

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  const [useMobileVersion, setUseMobileVersion] = useState(window.innerWidth <= 768);
  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
      setUseMobileVersion(window.innerWidth <= 768);
    }

    window.addEventListener('resize', handleResize)

    return _ => {
      window.removeEventListener('resize', handleResize)

    }
  })

  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
    setSubmenuOpen(false);
  };

  // Expects a string
  function UpdateMenu(key) {
    // Compare current menu key to the clicked item to determine if reload is necessary.
    if (currentMenuItem === key) {
      window.location.reload(false);
    }
    // Update current menu item
    setCurrentMenuItem(key);
};

// Expects a string
const MobileMenuClick = (key) => {
  setVisible(false);
  UpdateMenu(key);
};

  const getMenu = () => {
    return (
      <Menu
        className="Sider"
        theme="dark"
        mode="inline"
        onClick={(e) => {UpdateMenu(e.key)}}
        selectedKeys={[currentMenuItem]}>
        <Menu.Item key="/">
          Home
          <Link to="/" />
        </Menu.Item>
        <Menu.Item key="/donate">
          Data Donation
          <Link to="/donate" />
        </Menu.Item>
        <SubMenu
          className="Sider"
          key="sub2"
          title="Requesting Data Guides">
          <Menu.Item key="/guide/tiktok">
            TikTok
            <Link to="/guide/tiktok"/>
          </Menu.Item>
          <Menu.Item key="/guide/youtube">
            YouTube
            <Link to="/guide/youtube"/>
          </Menu.Item>
          <Menu.Item key="/guide/instagram">
            Instagram
            <Link to="/guide/instagram"/>
          </Menu.Item>          
        </SubMenu>
        <Menu.Item key="/about/researchers">
          Research Team
          <Link to="/about/researchers" />
        </Menu.Item>
      </Menu>
    );
  }

  function getMenuMobile() {
    return (
      <div>
        <div>
          <Button
            type="text"
            onClick={() => {MobileMenuClick("/")}}
            className="MenuButton"
          >
            <Link to="/" >Home</Link>
          </Button>
        </div>
        <div>
          <Button
            type="text"
            onClick={() => {MobileMenuClick("/donate")}}
            className="MenuButton"
          >
            <Link to="/donate" >DataDonation</Link>
          </Button>
        </div>
        <div>
          <Button
            type="text"
            onClick={() => {
              setSubmenuOpen(!submenuOpen);
            }}
            icon={submenuOpen ? <UpOutlined /> : <DownOutlined />}
            className="MenuButton"
          >
            Requesting Data Guides
          </Button>
        </div>
        <div>
          <Button
            type="text"
            onClick={() => {MobileMenuClick("/guide/tiktok")}}
            hidden={!submenuOpen}
            className="SubmenuButton"
          >
            <Link to="/guide/tiktok">TikTok</Link>
          </Button>
        </div>
        <div>
          <Button
            type="text"
            onClick={() => {MobileMenuClick("/guide/youtube")}}
            hidden={!submenuOpen}
            className="SubmenuButton"
          >
            <Link to="/guide/youtube">YouTube</Link>
          </Button>
        </div>
        <div>
          <Button
            type="text"
            onClick={() => {MobileMenuClick("/guide/instagram")}}
            hidden={!submenuOpen}
            className="SubmenuButton"
          >
            <Link to="/guide/instagram">Instagram</Link>
          </Button>
        </div>        
        <div>
          <Button
            type="text"
            onClick={() => {MobileMenuClick("/about/researchers")}}
            className="MenuButton"
          >
            <Link to="/about/researchers" >Research Team</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Router>
        <Layout>
          <Header
            className={'Header'}
            align="left"
          >
            <div>
              <Link to="/" onClick={() => {UpdateMenu("/")}}>
                <Image
                  className={'Logo'}
                  src={logo}
                  preview={false}
                />
                </Link>
              <Button className="MenuIconButton" type="text" onClick={showDrawer} hidden={!useMobileVersion}>
                <MenuOutlined />
              </Button>
              <Drawer
                placement="top"
                height="400"
                onClose={MobileMenuClick}
                visible={visible}
              >
                {getMenuMobile()}
              </Drawer>
            </div>
          </Header>
          <Layout>
            <Sider
              className="Sider"
              hidden={useMobileVersion}>
              {getMenu()}
            </Sider>
            <Content className="Main-content">
              <Route path="/guide/tiktok">
                <TikTokRequest />
              </Route>
              <Route path="/guide/youtube">
                <YouTubeRequest />
              </Route>
              <Route path="/guide/instagram">
                <InstagramRequest />
              </Route>              
              <Route path="/about/researchers">
                <AboutResearchers />
              </Route>
              <Route exact path="/donate">
                <PageDataDonation />
              </Route>
              <Route exact path="/">
                <PageHome />
              </Route>
            </Content>
          </Layout>
          <AppFooter />
        </Layout>
      </Router>
    </div>);
}

export default App;
